import React, {Component} from 'react';
import {inject, observer} from 'mobx-react';
import '../../assets/stylesheets/Game4.scss';
import Game4Step1 from './Game4Step1';
import Game4Step2 from './Game4Step2';
import Game4Step3 from './Game4Step3';
import Game4Step4 from './Game4Step4';
import Game4Step5 from './Game4Step5';
import Modal from 'react-modal';

@inject('AuthStore', 'SchoolStore', 'Game4Store', 'Navigator')
@observer
export default class Game4 extends Component {

    constructor(props) {
        super(props);

        this.state = {
            step: 1,
            navButtonLabels: [
                "Number of Teams",
                "Highest Level in class",
                "Start Game",
                "Next Question",
                "Continue Lesson"
            ],
            gameSteps: [
                <Game4Step1/>,
                <Game4Step2/>,
                <Game4Step3/>,
                <Game4Step4/>,
                <Game4Step5/>
            ],
            goToNextQuestion: false,
            revisedAnswer: false,
            selectedAnswer: false,
        };

        // Prevent unnecessary render
        this.teamAnswer = null;
    }

    componentDidMount() {
        this.props.Game4Store.loadQuestions();
    }

    handleNextStep() {

        if (this.state.step === 4 && this.state.revisedAnswer === true) {
            this.setState({goToNextQuestion: true, revisedAnswer: false});
        }

        if (this.teamAnswer) {
            const player = this.props.Game4Store.players.find(p => p.name === this.teamAnswer.player.name);
            player.score += this.props.Game4Store.answers[this.teamAnswer.index].points;
            this.teamAnswer = null;
            this._setWinners();
        }

        if (this.state.step === 5) {
            this.props.Navigator.push("/games");
            return;
        }

        if (this.state.step === 4
            && !(this.props.Game4Store.round === (this.props.Game4Store.numberRounds * this.props.Game4Store.players.length))) {
            this.props.Game4Store.round += 1;
            this.props.Game4Store.changeRound();
            return;
        }

        this.setState(
            prevState => {
                return {
                    step: prevState.step + 1
                }
            }
        )
    }

    _setWinners() {
        const playerOrdered = this.props.Game4Store.players.sort((a, b) => {
            return a.score < b.score;
        });

        let winners = [];
        let highScore = playerOrdered[0].score; // Gets the high score
        let loser;

        // Discover tie winners
        for (let w of playerOrdered) {
            if (w.score === highScore) {
                winners = [...winners, w];
            } else {
                loser = w;
            }
        }

        this.props.Game4Store.loser = loser;
        this.props.Game4Store.winners = winners;
    }

    handleChangeAnswer({player, index}) {
        this.teamAnswer = {player, index};
    }

    handleClose() {
        this.props.Navigator.push("/games")
    }

    openModal() {
        this.setState({modalIsOpen: true});
    }

    closeModal() {
        this.setState({modalIsOpen: false});
    }

    handleRevisedAnswer = (e) => {
        this.setState({revisedAnswer: e});
    };

    handleGoToNextQuestion = (e) => {
        this.setState({goToNextQuestion: e});
    };

    render() {

        const {
            step,
            gameSteps,
            navButtonLabels,
            goToNextQuestion,
            revisedAnswer
        } = this.state;

        const {
            players,
            maxLevel
        } = this.props.Game4Store;

        let cantGoNextStep = false;
        if (step === 3) {
            cantGoNextStep = maxLevel === -1;
        }

        if (step === 4) {
            cantGoNextStep = !revisedAnswer;
        }

        const customStyles = {
            overlay: {
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'black'
            },
            content: {
                top: '50%',
                left: '50%',
                right: 'auto',
                bottom: 'auto',
                marginRight: '-50%',
                transform: 'translate(-50%, -50%)',
                background: 'black',
                color: 'white'
            }
        };

        return (
            <div className="Game4 Page">
                <Modal
                    isOpen={this.state.modalIsOpen}
                    style={customStyles}
                    contentLabel="Modal"
                >
                    <h1>Would you like to leave the game?</h1>
                    <button className="btn-modal"
                            onClick={this.handleClose.bind(this)}>YES
                    </button>
                    <button className="btn-modal right"
                            onClick={this.closeModal.bind(this)}>NO
                    </button>
                </Modal>
                <div className="Close">
                    <button className="btn-close"
                            onClick={this.openModal.bind(this)}>X
                    </button>
                </div>
                {step !== 4
                    ? gameSteps[step - 1]
                    : <Game4Step4
                        goToNextQuestion={goToNextQuestion}
                        onRevisedAnswer={this.handleRevisedAnswer}
                        onGoToNextQuestion={this.handleGoToNextQuestion}
                        onChangeAnswer={this.handleChangeAnswer.bind(this)}/>
                }
                <div className="nav">
                    <button
                        className={"btn-nav-next"
                        + ((step === 2 && players.length === 0) || cantGoNextStep === true ? " disabled" : "")}
                        onClick={this.handleNextStep.bind(this)}>{navButtonLabels[step - 1]}</button>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/containers/Game4/Game4.js